// Props that should not be passed to the Input components:
const serverSideProps = ["index", "model"];
export default serverSideProps;
